module.exports = __webpack_public_path__ + "static/media/Brand_Your_Guest_App.0ba7c522.png";